import { GET_WEB_STATS } from './types';

const initialState = {
  loading: false,
  data: {},
};

export default class Organizations {
  static getWebStats(state = initialState, action) {
    switch (action.type) {
      case `${GET_WEB_STATS}_PENDING`:
        return { ...state, loading: true };
      case `${GET_WEB_STATS}_FULFILLED`:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      case `${GET_WEB_STATS}_REJECTED`:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      default:
        return state;
    }
  }
}
